import { render } from "./StudentListAdded.vue?vue&type=template&id=4c65a966"
import script from "./StudentListAdded.vue?vue&type=script&lang=js"
export * from "./StudentListAdded.vue?vue&type=script&lang=js"

import "./StudentListAdded.vue?vue&type=style&index=0&id=4c65a966&lang=scss"
script.render = render

export default script